module.exports = __webpack_public_path__ + "img/product-design.b6c8496b.svg";